import React, { useCallback, useEffect, useRef, useState } from "react";
import Icon, { IconTypes } from "components/Icon";
import FileSelector from "components/FileSelector/FileSelector";
import { upload } from "utils/fileUpload";
import { generate } from "short-uuid";
import { useCurrentUserContext } from "context/currentUserContext";
import { toast } from "react-toastify";
import { IChat } from "types/IChat";
import EmojiPicker from "emoji-picker-react";
import { ReactComponent as Attach } from "./../../../assets/images/attach_file.svg";
import { ReactComponent as PhotosFromGallery } from "./../../../assets/images/photos_from_gallery.svg";
import { ReactComponent as AttachDocs } from "./../../../assets/images/attach_docs.svg";
import { ReactComponent as CancelAttach } from "./../../../assets/images/cancel_attach.svg";
import { ReactComponent as SendBtn } from "./../../../assets/images/send_button.svg";
import { useDispatch, useSelector } from "react-redux";
import { viewFor } from "utils/constants";
import { getMobileOperatingSystem } from "utils/utils";
import { IChatInfo } from "stores/chats/chatInfo";
import { wssend } from "stores/socket";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { isMobile } from "utils/useragent";
import TextareaAutosize from "react-textarea-autosize";
import { loadCannedResponses } from "stores/chats/cannedResponses";
import { Drawer } from "@mui/material";
import { getAttachmentUrl } from "utils/formatChatData";

const attachButtons: Array<{
  icon: keyof IconTypes;
  label: string;
  key: string;
}> = [
  { icon: "attachRooms", label: "Choose room", key: "video" },
  { icon: "attachDocument", label: "Choose document", key: "document" },
  // { icon: "attachCamera", label: "Use camera", key: "camera" },
  { icon: "attachImage", label: "Choose image", key: "image" }
];

interface IChatInput {
  showAttach: boolean;
  setShowAttach: React.Dispatch<React.SetStateAction<boolean>>;
  newMessage: string;
  setNewMessage: React.Dispatch<React.SetStateAction<string>>;
  chatId: string;
  submitNewMessage: (message: any) => void;
  // cannedResponses: Array<any>;
  chatBusinessConfig: any;
  isAgent: Boolean;
  setShowKeyboardLockPopup: React.Dispatch<React.SetStateAction<boolean>>;
  messages: IChat;
}

const ChatInput = ({
  showAttach,
  setShowAttach,
  // showEmojis,
  // setShowEmojis,
  newMessage,
  chatId,
  setNewMessage,
  submitNewMessage,
  // cannedResponses,
  chatBusinessConfig,
  isAgent,
  setShowKeyboardLockPopup,
  messages
}: IChatInput) => {
  let filteredSuggestions: any = [];
  const chatInfo: IChatInfo = useSelector((state: any) => {
    return state.chatInfoReducer;
  });
  const dispatch = useDispatch();
  const hideTemplateSliderBtn = viewFor === "user";
  const isApp = isMobile();
  const [previewImages, setPreviewImages] = useState<string[]>([]);
  const detectEnterPress = (e: React.KeyboardEvent) => {
    if (
      newMessage.startsWith("/") &&
      (e.key === "Enter" || e.keyCode === 13) &&
      !e.shiftKey
    ) {
      e.preventDefault();
      setNewMessage(filteredSuggestions[activeSuggestion].message);
    } else if ((e.key === "Enter" || e.keyCode === 13) && !e.shiftKey) {
      // submitNewMessage();
      if (isEnterToSend) {
        e.preventDefault();

        onSendMessage();
      }
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      setActiveSuggestion(activeSuggestion - 1);
    } else if (e.keyCode === 40) {
      if (activeSuggestion === filteredSuggestions.length - 1) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  const onChatInputChange = async (e: React.FormEvent<HTMLTextAreaElement>) => {
    const newChatMsg = e.currentTarget.value;
    setNewMessage(newChatMsg);
  };

  const Suggestions = () => {
    filteredSuggestions = [];
    let filteredSuggestionsBodyMarkup: Array<any> = [];
    let i = 0;

    cannedResponses.map(function (e: any) {
      if (
        newMessage.length > 0 &&
        newMessage.startsWith("/") &&
        (e.keyword.includes(newMessage.substring(1)) ||
          e.message.includes(newMessage.substring(1)))
      ) {
        filteredSuggestions.push(e);
        filteredSuggestionsBodyMarkup.push(
          <li className="filteredSuggestion">
            <div
              className={
                activeSuggestion == i++
                  ? "activeSuggestion"
                  : "inactiveSuggestion"
              }
              onClick={() => setNewMessage(e.message)}
            >
              {/* <img
                  src={
                    "https://assets.toothsi.in/apple_icon_57x57_f34cbed150.png"
                  }
                  className="avatar"
                /> */}
              <div className="suggestion-content">
                <p className="suggestion-key" title={e.keyword}>
                  {e.keyword}
                </p>
                <p className="suggestion-value" title={e.message}>
                  {e.message}
                </p>
              </div>
            </div>
          </li>
        );
      }
    });

    return (
      <>
        {filteredSuggestionsBodyMarkup.length !== 0 && (
          <div className="suggestions">
            <ul className="filteredSuggestions">
              {filteredSuggestionsBodyMarkup}
            </ul>
          </div>
        )}
      </>
    );
  };
  const operatingSystem = getMobileOperatingSystem();
  const { currentUser } = useCurrentUserContext();
  const videoSelector = useRef<FileSelector | null>(null);
  const imageSelector = useRef<FileSelector | null>(null);
  const documentSelector = useRef<FileSelector | null>(null);
  const [attachments, setAttachments] = useState<File[]>([]);
  const [uploadInProgress, setUploadInProgress] = useState("done");
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [cannedResponses, setCannedResponses] = useState<any>([]);
  const chatInp = useRef<HTMLTextAreaElement>(null);
  const [isEnterToSend, setIsEnterToSend] = useState<boolean>(
    localStorage.getItem("isEnterToSend") === "false" && !isMobile()
      ? false
      : true
  );

  useEffect(() => {
    if (localStorage) {
      localStorage.setItem("isEnterToSend", isEnterToSend?.toString());
    }
  }, [isEnterToSend]);

  // const [messageObj, setMessageObj] = useState({
  //   userId: currentUser.id,
  //   agentId: "",
  //   type: "text"
  // });
  const onFileChange = useCallback((e, type) => {
    if (e?.target?.files) {
      const files = [];
      for (let key in e.target.files) {
        if (!isNaN(Number(key))) {
          files.push(e.target.files[key]);
        }
      }
      if (files[0].type.includes("video")) {
        type = "video";
      }
      setAttachments(files);
      uploadAttachments(files, type);
    }
  }, []);
  const onAttachBtnClick = (key: string) => {
    switch (key) {
      case "image":
        imageSelector.current?.triggerClick(false, "image");
        break;
      case "video":
        videoSelector.current?.triggerClick(false, "video");
        break;
      case "document":
        documentSelector.current?.triggerClick(false, "document");
        break;
      case "camera":
        break;
      default:
        throw new Error("");
    }
    setShowAttach(!showAttach);
  };
  const uploadAttachments = (attachments: File[], type?: string) => {
    if (!attachments || !attachments.length) {
      return;
    }
    const _chatId = chatId || "192x0";
    const userId = currentUser?.id || "10028";
    setUploadInProgress("inprogress");
    // as of now upload only single attachment
    // const attachment = attachments[0]
    const uploadPromiseArr: Array<Promise<{ url: string }>> = [];
    attachments.forEach((cur) => {
      uploadPromiseArr.push(
        upload(cur, {
          businessType: "skinnsi",
          mobile: 9930023473,
          mimeType: cur.type,
          purpose: "chatAppUploads",
          objectKey: `beta/${_chatId}_${userId}/${generate()}`
        })
      );
    });
    Promise.all(uploadPromiseArr)
      .then((data) => {
        const attachmentIds = data.map((cur) => cur.url);
        if (attachmentIds[0]) {
          const customMessageObj = {
            senderId: currentUser?.id,
            senderType: viewFor,
            type,
            source: "ATTACHMENT",
            attchUrl: attachmentIds[0],
            attchName: attachments[0].name,
            timeStamp: new Date().toISOString(),
            msgType: "freeText",
            msgSource: "whatsapp"
          };
          const isImage = attachments[0].type.includes("image");
          // setMessageObj(customMessageObj);
          if (chatInp?.current?.value && isImage) {
            setPreviewImages((prev) => [...prev, attachmentIds[0]]);
            setAttachments([]);
            setUploadInProgress("done");
            return;
          }
          onSendMessage(customMessageObj);
          setAttachments([]);
          setUploadInProgress("done");
        } else {
          throw new Error("Error Uploading Attachments!");
        }
      })
      .catch((err) => {
        setAttachments([]);
        setUploadInProgress("done");
        console.log(err);
      });
  };
  const onSendMessage = async (customMessageObj?: any) => {
    if (uploadInProgress === "inprogress") {
      return;
    }
    if (attachments && attachments.length) {
      uploadAttachments(attachments);
    }
    let newObj =
      customMessageObj && customMessageObj.source == "ATTACHMENT"
        ? customMessageObj
        : null;

    if (newMessage && previewImages?.length) {
      newObj = {
        mediaUrls: [...previewImages]
      };
      setPreviewImages([]);
    }
    submitNewMessage(newObj);
  };

  function checkOptStatus() {
    if (
      chatInfo.botName === "wa_app_support_bot" ||
      chatInfo.botName == "makeo_buddy"
    ) {
      return false;
    }
    return chatBusinessConfig.optStatus === false;
  }

  const showTemplateSlider = () => {
    let lockCondition =
      isAgent && chatInfo?.botName != "makeo_buddy" &&
      (checkOptStatus() ||
        (chatBusinessConfig.template <= 0 &&
          chatBusinessConfig.templateSMS <= 0) ||
        !chatBusinessConfig.isAllowedToChatPerOfficeHoursConfig ||
        chatInfo.currentOwner === "BOT");
    
    if(isAgent && chatInfo && chatInfo.botName == "makeo_buddy"){
      lockCondition = false;
    }

    if (lockCondition) {
      let reason = "";

      if (chatBusinessConfig.optStatus === false) {
        reason = "Customer has opted out our messages service.";
      } else if (
        chatBusinessConfig.template <= 0 &&
        chatBusinessConfig.templateSMS <= 0
      ) {
        reason = "Canned message limit reached";
      } else if (!chatBusinessConfig.isAllowedToChatPerOfficeHoursConfig) {
        reason = "Business configurations (business hours) not met.";
      } else if (chatInfo.currentOwner === "BOT" && isAgent) {
        reason = "Cannot send messages to chat assigned to BOT";
      }

      window.parent.postMessage({
        type: "showToast",
        msgType: "error",
        errorMsg: reason
      });
      return;
    }

    window.parent.postMessage(
      {
        type: "showSlider",
        options: null
      },
      "*"
    );
  };
  const showSendButton =
    newMessage ||
    (previewImages && previewImages.length) ||
    (attachments && attachments.length) ||
    uploadInProgress !== "done";

  let showTemplateButton = true;

  let lockCondition =
    isAgent &&
    (checkOptStatus() ||
      chatInfo.currentOwner === "BOT" ||
      chatBusinessConfig.userMessaged === false ||
      chatBusinessConfig.freeText <= 0 ||
      !chatBusinessConfig.isAllowedToChatPerOfficeHoursConfig);

  if(isAgent && chatInfo && chatInfo.botName == "makeo_buddy"){
    lockCondition = false;
  }

  const isCustomerMode =
    window.location.search.indexOf("customermode=true") > -1;

  if (isCustomerMode) {
    lockCondition = false;
    showTemplateButton = false;
  }

  let keyBoardLockReason = "";

  if (lockCondition) {
    if (chatBusinessConfig.optStatus === false) {
      keyBoardLockReason = "Customer has opted out our messages service.";
    } else if (chatBusinessConfig.userMessaged === false) {
      if (Object.keys(messages).length) {
        keyBoardLockReason = "User did not respond in last 24 hours.";
      } else {
        keyBoardLockReason = "Please send template message.";
      }
    } else if (chatBusinessConfig.freeText <= 0) {
      keyBoardLockReason = "Free text limit reached";
    } else if (!chatBusinessConfig.isAllowedToChatPerOfficeHoursConfig) {
      keyBoardLockReason = "Business configurations (business hours) not met.";
    }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        wssend(
          // @ts-ignore
          JSON.stringify({
            action: "typing",
            data: {
              chatId,
              message: newMessage,
              user: currentUser?.type
            }
          })
        )
      );
    }, 300);
    return () => clearTimeout(timeout);
  }, [newMessage, chatId, dispatch, currentUser]);

  useEffect(() => {
    new Promise((resolve, reject) => {
      dispatch(
        loadCannedResponses({
          key: "quick_reply",
          resolve,
          reject
        })
      );
    }).then((data: any) => {
      if (data.isSuccess) {
        setCannedResponses(data.quickReplies);
      }
    });
  }, [dispatch]);

  const EmojiContainer = (
    <div className="smiley-container">
      <Icon
        id={"smiley"}
        className="smiley"
        color="#e03c31"
        onClick={() => {
          setShowEmoji(!showEmoji);
        }}
      />
      <div className="emoji-container">
        {showEmoji ? (
          <EmojiPicker
            onEmojiClick={(e, emojiObject: any) => {
              if (chatInp.current) {
                const pos = chatInp.current.selectionStart;
                let val = chatInp.current.value;
                val =
                  val.substr(0, pos) + emojiObject.emoji + val.substr(pos + 1);
                setNewMessage(val);
              }
              setShowEmoji(false);
            }}
            disableAutoFocus={true}
            // native
          />
        ) : null}
      </div>
    </div>
  );

  const attachmentBtn = (os: string) => {
    return (
      <button
        className={`attach-btn-new ${os}`}
        aria-label="Attach"
        onClick={() => {
          if (!lockCondition) {
            setShowAttach(!showAttach);
            setShowSuggestion(false);
          }
        }}
      >
        {showAttach ? <CancelAttach /> : <Attach />}
      </button>
    );
  };

  const textArea = (
    <div className="input-container pos-rel">
      <div
        className={`input-container__field ${
          previewImages?.length > 0 ? "reduce-border" : ""
        }`}
      >
        <TextareaAutosize
          className={`chat__input unlocked ${
            showSendButton ? "chat__input-adj-width" : ""
          }`}
          placeholder="Type here..."
          value={newMessage}
          onChange={(e) => onChatInputChange(e)}
          onKeyDown={detectEnterPress}
          ref={chatInp}
          rows={1}
          style={{
            overflow: "auto",
            resize: "none",
            fontSize: "14px",
            color: "#455A60"
          }}
          onFocus={() => {
            setShowEmoji(false);
            setShowSuggestion(true);
            setShowAttach(false);
          }}
          onBlur={(e) => {
            if (e.relatedTarget?.classList.contains("send_btn")) {
              chatInp.current?.focus();
            }
          }}
          maxRows={4}
        />
        {previewImages.length > 0 && (
          <div className="chat__media-container">
            {previewImages?.map((item, indx) => (
              <div className="chat__media-wrapper" key={indx}>
                <img
                  src={getAttachmentUrl(item)}
                  alt="#"
                  className="chat__media"
                />
                <button
                  type="button"
                  className="chat__media-btn"
                  onClick={() => {
                    setPreviewImages(
                      previewImages.filter((img) => img !== item)
                    );
                  }}
                >
                  <Icon id="greyCross" />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* <textarea
        className={`chat__input unlocked ${
          showSendButton ? "chat__input-adj-width" : ""
        }`}
        placeholder="Type here..."
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyDown={detectEnterPress}
        ref={chatInp}
        rows={1}
        style={{ overflow: "auto", resize: "none" }}
        onFocus={() => setShowEmoji(false)}
        onBlur={(e) => {
          if (e.relatedTarget?.classList.contains("send_btn")) {
            chatInp.current?.focus();
          }
        }}
      ></textarea> */}
      {getMobileOperatingSystem() === "Android"
        ? attachmentBtn("Android")
        : null}
    </div>
  );

  const lockedInput = (
    <div
      onClick={() => {
        return;
        setShowKeyboardLockPopup(true);
      }}
      style={{ width: "100%" }}
    >
      <input
        className={`locked_keyboard chat__input ${
          showSendButton ? "chat__input-adj-width" : ""
        }`}
        placeholder={`keyboard locked. ${keyBoardLockReason}`}
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyDown={detectEnterPress}
        disabled
      />
    </div>
  );

  const sendBtn =
    uploadInProgress === "done" ? (
      <div
        aria-label="Send message"
        className="send_btn"
        onClick={onSendMessage}
        tabIndex={-1}
        // style={{ paddingLeft: 10 }}
      >
        {/* <Icon id="send" className="chat__input-icon" /> */}
        {/* <SendBtn /> */}

        {showSendButton ? <Icon id="activeSendIcon" /> : <Icon id="sendIcon" />}
      </div>
    ) : (
      <button>
        <Icon
          id="circularLoader"
          fill="rgb(0, 216.5, 187.0288)"
          className="chat__input-icon"
        />
      </button>
    );

  const templateSliderBtn = (
    <button
      className="showTemplateWrapper"
      aria-label="Show templates"
      onClick={showTemplateSlider}
    >
      <Icon id="showTemplate" />
    </button>
  );
  const uploadBottomDrawer = (
    <>
      <div
        id="chat_attach_item_image"
        className="chat_attach_item"
        onClick={() => onAttachBtnClick("image")}
      >
        <div className="chat_attach_item-iconWrapper">
          <PhotosFromGallery />
        </div>
        Photos from gallery
      </div>
      <div
        id="chat_attach_item_document"
        className="chat_attach_item"
        onClick={() => onAttachBtnClick("document")}
      >
        <div className="chat_attach_item-iconWrapper">
          <AttachDocs />
        </div>
        Attach documents
      </div>
    </>
  );

  return (
    <>
      {/* Image / Video */}
      <FileSelector
        onChange={(e: React.FormEvent<HTMLInputElement>) =>
          onFileChange(e, "image")
        }
        accept="image/*,video/*"
        ref={imageSelector}
      />
      {/* Any Document */}
      <FileSelector
        onChange={(e: React.FormEvent<HTMLInputElement>) =>
          onFileChange(e, "document")
        }
        ref={documentSelector}
        accept={"application/pdf,application/msword,text/plain"}
      />
      {showSuggestion && viewFor === "agent" && <Suggestions />}
      <div className={`chat__input-wrapper ${operatingSystem}`}>
        {!lockCondition && viewFor === "agent" && (
          <div className="hide-in-mobile">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isEnterToSend}
                    onChange={(e) => {
                      localStorage.setItem(
                        "isEnterToSend",
                        e.target.checked.toString()
                      );
                      setIsEnterToSend(e.target.checked);
                    }}
                    className={"enter_to_send"}
                  />
                }
                label="Enter to send"
                color="primary"
              />
            </FormGroup>
          </div>
        )}
        {/* {!lockCondition && EmojiContainer} */}
        <div className="pos-rel chat__input__holder">
          {!lockCondition &&
            operatingSystem !== "Android" &&
            attachmentBtn("iOS")}
          {lockCondition ? lockedInput : textArea}
          {!showSendButton && !hideTemplateSliderBtn ? templateSliderBtn : null}
          {(viewFor === "user" || showSendButton) && sendBtn}
        </div>
      </div>
      {showAttach && (
        <>
          {isApp ? (
            <Drawer
              open={showAttach}
              anchor="bottom"
              onClose={() => setShowAttach(false)}
            >
              <div
                className="chat__mobile-modal--cls-btn"
                onClick={() => setShowAttach(false)}
              >
                <Icon id="closeIcon" />
              </div>
              <div className="chat__mobile-modal">{uploadBottomDrawer}</div>
            </Drawer>
          ) : (
            <div className="chat_attach_new">{uploadBottomDrawer}</div>
          )}
        </>
      )}
    </>
  );
};

export default ChatInput;
